import approvePayment from '@/locales/en/approvePayment.json';
import confirmDecommissioningChecklistData from '@/locales/en/confirmDecommissioningChecklistData.json';
import confirmEquipmentCertificates from '@/locales/en/confirmEquipmentCertificates.json';
import confirmIncomeQualification from '@/locales/en/confirmIncomeQualification.json';
import confirmManualJReport from '@/locales/en/confirmManualJReport.json';
import confirmMultipliers from '@/locales/en/confirmMultipliers.json';
import confirmPreApproval from '@/locales/en/confirmPreApproval.json';
import confirmSiteDetails from '@/locales/en/confirmSiteDetails.json';
import contractorsList from '@/locales/en/contractorsList.json';
import determineEquipmentRemovedEfficiency from '@/locales/en/determineEquipmentRemovedEfficiency.json';
import provideEquipmentCatalogDetails from '@/locales/en/provideEquipmentCatalogDetails.json';
import recordEnrollementResults from '@/locales/en/recordEnrollementResults.json';
import recordOptionalPreApprovalResultsNyCleanHeatConEd from '@/locales/en/recordOptionalPreApprovalResultsNyCleanHeatConEd.json';
import resolveSubmitTasks from '@/locales/en/resolveSubmitTasks.json';
import reviewCommissioningForm from '@/locales/en/reviewCommissioningForm.json';
import reviewEnergyUsageElectric from '@/locales/en/reviewEnergyUsageElectric.json';
import reviewEnergyUsageGas from '@/locales/en/reviewEnergyUsageGas.json';
import reviewInstalledHeatPump from '@/locales/en/reviewInstalledHeatPump.json';
import reviewInstalledWaterHeater from '@/locales/en/reviewInstalledWaterHeater.json';
import reviewPermit from '@/locales/en/reviewPermit.json';
import reviewPostCasTesting from '@/locales/en/reviewPostCasTesting.json';
import reviewPreCasTesting from '@/locales/en/reviewPreCasTesting.json';
import reviewPreHomeSafetyAssessment from '@/locales/en/reviewPreHomeSafetyAssessment.json';
import reviewPreInstallDetails from '@/locales/en/reviewPreInstallDetails.json';
import reviewPreLimitedHvacAssessment from '@/locales/en/reviewPreLimitedHvacAssessment.json';
import reviewSignedApplication from '@/locales/en/reviewSignedApplication.json';
import reviewSiteDetails from '@/locales/en/reviewSiteDetails.json';
import reviewUploadedCommissioningForm from '@/locales/en/reviewUploadedCommissioningForm.json';
import reviewUploadedDecommissioningForm from '@/locales/en/reviewUploadedDecommissioningForm.json';
import startIncomeQualification from '@/locales/en/startIncomeQualification.json';
import submitForPreApproval from '@/locales/en/submitForPreApproval.json';
import submitForPreApprovalCATECHSFV from '@/locales/en/submitForPreApprovalCATECHSFV.json';
import submitForPreApprovalCODRCOG from '@/locales/en/submitForPreApprovalCODRCOG.json';
import submitForPreApprovalCOHEAR from '@/locales/en/submitForPreApprovalCOHEAR.json';
import submitJobForEnrollment from '@/locales/en/submitJobForEnrollment.json';
import submitJobForEnrollmentCAHEEHRA from '@/locales/en/submitJobForEnrollmentCAHEEHRA.json';
import submitJobForEnrollmentCATECH from '@/locales/en/submitJobForEnrollmentCATECH.json';
import submitOptionalPreApprovalNyCleanHeatConEd from '@/locales/en/submitOptionalPreApprovalNyCleanHeatConEd.json';
import termsAndConditions from '@/locales/en/termsAndConditions.json';
import uploadFuelSwitchingCalculator from '@/locales/en/uploadFuelSwitchingCalculatorForm.json';
import validateEligibility from '@/locales/en/validateEligibility.json';
import {
  loadSharedEsMessages,
  type LocaleMessageLoaders,
  sharedEnI18n
} from '@shared/i18n';
import { createI18n } from 'vue-i18n';

export const localeMessageLoaders: LocaleMessageLoaders = {
  es: loadSharedEsMessages
};

export default createI18n({
  legacy: false,
  locale: 'en', // default language
  fallbackLocale: 'en', // fallback language in case a translation is not found
  // Internal-only screens aren't translated, so Spanish falls back to English there by design
  fallbackWarn: false,
  messages: {
    en: {
      ...sharedEnI18n,
      ...contractorsList,
      ...reviewSiteDetails,
      ...reviewEnergyUsageElectric,
      ...reviewEnergyUsageGas,
      ...reviewPreInstallDetails,
      ...reviewPreCasTesting,
      ...reviewPostCasTesting,
      ...reviewInstalledHeatPump,
      ...reviewInstalledWaterHeater,
      ...confirmSiteDetails,
      ...confirmIncomeQualification,
      ...confirmMultipliers,
      ...confirmPreApproval,
      ...determineEquipmentRemovedEfficiency,
      ...submitJobForEnrollment,
      ...submitJobForEnrollmentCATECH,
      ...submitJobForEnrollmentCAHEEHRA,
      ...recordEnrollementResults,
      ...submitForPreApproval,
      ...submitForPreApprovalCATECHSFV,
      ...submitForPreApprovalCOHEAR,
      ...submitForPreApprovalCODRCOG,
      ...approvePayment,
      ...provideEquipmentCatalogDetails,
      ...reviewPreLimitedHvacAssessment,
      ...reviewPreHomeSafetyAssessment,
      ...termsAndConditions,
      ...reviewCommissioningForm,
      ...reviewUploadedCommissioningForm,
      ...reviewUploadedDecommissioningForm,
      ...uploadFuelSwitchingCalculator,
      ...resolveSubmitTasks,
      ...startIncomeQualification,
      ...confirmManualJReport,
      ...confirmEquipmentCertificates,
      ...confirmDecommissioningChecklistData,
      ...reviewPermit,
      ...reviewSignedApplication,
      ...validateEligibility,
      ...submitOptionalPreApprovalNyCleanHeatConEd,
      ...recordOptionalPreApprovalResultsNyCleanHeatConEd
    }
  }
});
